import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';

/**
 * Reload data in viewport but do not lose scroll position
 *
 * Useful when row set does not change and only data vertically in viewport should be reloaded
 *
 * @see reloadTableData
 */
export const reloadTableDataInViewport: ApiTableCommandFactory =
  (cmdContext) => () => {
    // synchroneously reset data to [] so useAutoSizedColumns hook sees it and does
    // not try to relaculate column widths before new data is loaded
    cmdContext.updateState((draft) => {
      draft.data = [];
    });
    const rowRange = cmdContext.getTableModel().visibleRowRange;
    if (rowRange) {
      // must postpone to next tick so that lazyLoadRows hook sees reset of state.data to []
      setTimeout(() => {
        cmdContext
          .getLazyLoadRows()
          .handleRequestRowRange(rowRange.startIndex, rowRange.endIndex);
      }, 0);
    }
  };
